import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const QuestionOrAnswer = ({ value, type }) => (

    <p className={`${type}`}>
        {value}
    </p>
);

QuestionOrAnswer.propTypes = {
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
};

export default QuestionOrAnswer;

